<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<loading v-if="isLoading" text="Kategori listesi yükleniyor..." size="80" width="2"/> 
						
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details :prepend-inner-icon="mdiMagnify"
									v-model="filterText" placeholder="Kategori Ara" clearable></v-text-field>

								<v-btn icon @click="editItem()">
									<v-icon>{{mdiPlus}}</v-icon>
								</v-btn>
							</v-toolbar>

							<v-list two-line>
								<template v-for="(item, itemIndex) in getItems">
									<v-list-item :key="itemIndex" avatar @click="editItem(item)">
										<v-list-item-icon>
											<v-icon :color="item.color">{{mdiPalette}}</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title> {{item.name}} </v-list-item-title>
											<v-list-item-subtitle > {{item.location}} </v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<!-- <v-btn icon v-on:click.stop.prevent="askForRemove(item)"> -->
											<v-btn icon>
												<v-icon color="indigo">{{mdiTooltipEdit}}</v-icon>
											</v-btn>
										</v-list-item-action>
									</v-list-item>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<v-dialog v-model="dialogEditor" persistent max-width="600px">
					<v-card>
						<v-card-title>
							<span class="headline" v-if="item.id">Düzenle</span>
							<span class="headline" v-if="!item.id">Yeni Ekle</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap>
									<v-flex xs12 mb-3>
										<v-text-field label="Kategori Adı" v-model="item.name" outlined hide-details placeholder="Örn: Lanxess Germany"></v-text-field>
									</v-flex>
									<v-flex xs12 mb-3>
										<v-text-field label="Lokasyon" v-model="item.location" outlined hide-details placeholder="Örn: GER"></v-text-field>
									</v-flex> 
									<v-flex xs12>
										<div class="caption">Renk</div>
										<v-color-picker
											v-model="item.color"
											hide-canvas
											hide-inputs 
											mode="hex"  
										></v-color-picker>
									</v-flex> 
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions class="pr-4 pl-4 pb-4"> 
							<v-btn color="error darken-1" text  @click="askForRemove()" v-if="item.id"> Kategoriyi Sil</v-btn> 
							<v-spacer></v-spacer> 
							<v-btn color="warning" round outlined @click="closeItem()">İptal</v-btn>
							<v-btn color="success" round outlined @click="saveItem()">Kaydet</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



				<v-dialog v-model="dialogRemove" max-width="290">
					<v-card> 
						<v-card-title class="headline" color="error"> Silmek itediğine emin misin ?</v-card-title> 
						<v-card-actions> 
							<v-btn color="green darken-1" text  @click="closeForRemove()"> Vazgeç </v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" text  @click="removeItem()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>





			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	import loading from "@/components/utils/loading"
	import { mdiMagnify,mdiPlus,mdiReload,mdiCloseCircle,mdiPalette,mdiTooltipEdit } from '@mdi/js';
    export default {
		components:{
			loading
		},
		data :()=>({
			mdiMagnify: mdiMagnify,
			mdiPlus: mdiPlus,
			mdiReload: mdiReload,
			mdiCloseCircle: mdiCloseCircle,
			mdiPalette: mdiPalette,
			mdiTooltipEdit: mdiTooltipEdit,

			isLoading : false,
			dialogEditor : false,
			dialogRemove : false,
			filterText : "",
			items: [],
			item : {id:"",name : "",location : "",color:'#ff0000'},
		}), 
		mounted(){  
			this.loadItems();
			this.setNewItemData();
		},
		methods:{
			loadItems(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/categories/").then(response => {  
					this.items = response.body; 
					this.isLoading = false;
					this.dialogEditor = false;
					this.dialogRemove = false;
				})  
			},
			setNewItemData(){
				this.item = {id:"",name : "",location : "",color:'#ff0000'}
			}, 
			editItem(item){
				if(item){
					this.item = item;
				}else{
					this.setNewItemData();
				}
				this.dialogEditor = true;
			},
			closeItem(){
				this.dialogEditor = false
			},
			askForRemove(){ 
				this.dialogEditor = false;
				this.dialogRemove = true;
			},
			closeForRemove(){ 
				this.dialogRemove = false;
			},
			saveItem(){
				this.isLoading = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/categories/save", this.item).then(response => {  
					this.loadItems();
				}) 
			},
			removeItem(){
				this.isLoading = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/categories/remove", this.item).then(response => {  
					this.loadItems();
				}) 
			}
		},
		computed:{
			getItems(){
				var items = []; 
				var filterText = this.filterText == null || this.filterText == "" ? "" : this.filterText.seoUrl(); 
				items = this.filterText == null || this.filterText == "" ? this.items : this.items.filter( function(item) { 
					if( item.name.seoUrl().indexOf(filterText) < 0 ){ return false; }
					return true;
				})  
				items.sort(function(a, b) {
					var nameA = a.name.toUpperCase(); 
					var nameB = b.name.toUpperCase(); 
					if (nameA < nameB) { return -1; }
					if (nameA > nameB) { return 1; } 
					return 0;
				});
				return items;
			}
		}
    }
</script>